import { makeHttpRequest } from "@/shared";

/**
 * Fetches a short-lived Jivo user token from backend.
 * @returns {Promise<{token: string, expiresAt?: string|number, expiresAtUnix?: number}>}
 */
export async function getJivoUserToken() {
    const { data } = await makeHttpRequest({
        url: "jivo/token",
        method: "GET",
        headers: { Accept: "application/json" },
    });

    return data;
}
